import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importToHeading: {
		id: 'project-create-importer-upload-flow.select-product-screen.product-tile.import-to-heading',
		defaultMessage: 'Import to {productName}',
		description: 'Import to product heading',
	},
	idealFor: {
		id: 'project-create-importer-upload-flow.select-product-screen.product-tile.ideal-for',
		defaultMessage: 'Ideal for:',
		description: 'Description for which type of team the product is suitable for',
	},
});
